function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#6EC18A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.44
}, React.createElement("path", {
  d: "M13.725 25.977L24.899 38.965 56.558 0",
  transform: "translate(7.646 7.646)"
}), React.createElement("path", {
  d: "M48.832 27.832c1.56 9.977-3.282 19.866-12.133 24.783-8.851 4.916-19.84 3.82-27.537-2.747-7.698-6.567-10.477-17.216-6.963-26.686 3.513-9.471 12.575-15.76 22.71-15.76 3.195-.004 6.36.624 9.31 1.849",
  transform: "translate(7.646 7.646)"
}));

var SvgConfirmation = function SvgConfirmation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfirmation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirmation.709479fe.svg";
export { ForwardRef as ReactComponent };